import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedCommonModule } from 'app/back-office/shared/common.module';
import { BadgeGeneratorComponent } from './badge-generator.component';
@NgModule({
  imports: [
    CommonModule,
    SharedCommonModule,
    NgbModule,
    TranslateModule.forChild()
  ],
  declarations: [
    BadgeGeneratorComponent
  ],
  exports: [
    BadgeGeneratorComponent
  ],
  providers: [
  ]
})
export class BadgeGeneratorModule { }
